<!-- Small container for views -->
<script setup lang="ts"></script>

<template>
    <div class="grid place-items-center size-full px-10 pt-12 md:pt-16">
        <div class="md:max-w-[370px] w-full">
            <slot />
        </div>
    </div>
</template>

<style scoped></style>
